// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paymnt_partts{
    max-width: 980px;
    width: 100%;
    background: #004aad;
    margin: 0 auto;
    padding: 30px;
    border-radius: 10px;
}

.paymnt_box{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    flex-direction: column;
    padding: 100px 0;
}
.pay_logo{
    text-align: center;
    margin-bottom: 40px;
}
.stripe_cont{
    position: relative;
}
.stripe_cont:before{
    content: "";
    position: absolute;
    width: 50%;
    height: 100%;
    background: rgba(11,112,181,0.5);
}
.paymnt_inner{
    padding: 20px;
    border: 1px solid #99aec9;
    border-radius: 10px;
    position: relative;
}

.paymnt_inner .pay_card{
    
    background: inherit;
    margin-top: -35px;
    text-align: center;
}

.paymnt_inner .pay_card h2{
    font-size: 16px;
    color: #fff;
    font-weight: 500;
    background: #004aad;
    display: inline-block;
   
    padding:5px  10px;
}

.payment_inner_box{
    max-width: 60%;
    width: 100%;
    margin: 30px auto 0 auto;
    text-align: left;
}

.payment_inner_box label{
    color: #fff;
    font-size:16px;
    font-weight: 500;
}

.pay_button{
    text-align: center;
    margin-top: 30px;
}

.pay_button .pay_but{
    background: #123377;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0,0,0,0.2);
    padding: 5px 40px;
    border: 0px;
    font-size: 18px;
    text-transform: uppercase;
}
.field_partts{
    position: relative;
}

.cvc_number{
    position: absolute;
    bottom: 5px;
    right: 10px;
}

.select_box{
    display: flex;
    position: absolute;
    left: 0;
    bottom: 0px;
    
}
.select_box:focus{
    box-shadow: none;
    outline: 0px;
}
.stripe_select{
    border: 0;
    background: transparent;
    height: 50px;
    padding: 0px;
    
}

.select_1{
    width: 30%;
}

.select_2{
    width: 50%;
}
.package_details label{
    color: #fff;
    display: block;
    font-size: 18px;
    padding: 5px 0;
}
.package_details label span{
    display: inline-block;
    font-size: 22px;
    margin-left: 20px;
    font-weight: 600;
}


.pay_loader, .pay_loader2{
    width: 100%;
}
@media screen and (max-width:991px){
    .payment_inner_box{
        max-width: 90%;
    }
    .pay_logo img{
        max-width: 100%;
        height: auto;
        padding: 0 20px;
    }
    /* .paymnt_partts{
        margin: 0 20px;
    } */
}`, "",{"version":3,"sources":["webpack://./src/pages/payment/payment.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;;IAErB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,oCAAoC;IACpC,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,WAAW;;AAEf;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,SAAS;IACT,uBAAuB;IACvB,YAAY;IACZ,YAAY;;AAEhB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,cAAc;IACd,eAAe;IACf,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA;IACI,WAAW;AACf;AACA;IACI;QACI,cAAc;IAClB;IACA;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;IACA;;OAEG;AACP","sourcesContent":[".paymnt_partts{\n    max-width: 980px;\n    width: 100%;\n    background: #004aad;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 10px;\n}\n\n.paymnt_box{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    flex-direction: column;\n    padding: 100px 0;\n}\n.pay_logo{\n    text-align: center;\n    margin-bottom: 40px;\n}\n.stripe_cont{\n    position: relative;\n}\n.stripe_cont:before{\n    content: \"\";\n    position: absolute;\n    width: 50%;\n    height: 100%;\n    background: rgba(11,112,181,0.5);\n}\n.paymnt_inner{\n    padding: 20px;\n    border: 1px solid #99aec9;\n    border-radius: 10px;\n    position: relative;\n}\n\n.paymnt_inner .pay_card{\n    \n    background: inherit;\n    margin-top: -35px;\n    text-align: center;\n}\n\n.paymnt_inner .pay_card h2{\n    font-size: 16px;\n    color: #fff;\n    font-weight: 500;\n    background: #004aad;\n    display: inline-block;\n   \n    padding:5px  10px;\n}\n\n.payment_inner_box{\n    max-width: 60%;\n    width: 100%;\n    margin: 30px auto 0 auto;\n    text-align: left;\n}\n\n.payment_inner_box label{\n    color: #fff;\n    font-size:16px;\n    font-weight: 500;\n}\n\n.pay_button{\n    text-align: center;\n    margin-top: 30px;\n}\n\n.pay_button .pay_but{\n    background: #123377;\n    border-radius: 10px;\n    box-shadow: 0 0 10px rgba(0,0,0,0.2);\n    padding: 5px 40px;\n    border: 0px;\n    font-size: 18px;\n    text-transform: uppercase;\n}\n.field_partts{\n    position: relative;\n}\n\n.cvc_number{\n    position: absolute;\n    bottom: 5px;\n    right: 10px;\n}\n\n.select_box{\n    display: flex;\n    position: absolute;\n    left: 0;\n    bottom: 0px;\n    \n}\n.select_box:focus{\n    box-shadow: none;\n    outline: 0px;\n}\n.stripe_select{\n    border: 0;\n    background: transparent;\n    height: 50px;\n    padding: 0px;\n    \n}\n\n.select_1{\n    width: 30%;\n}\n\n.select_2{\n    width: 50%;\n}\n.package_details label{\n    color: #fff;\n    display: block;\n    font-size: 18px;\n    padding: 5px 0;\n}\n.package_details label span{\n    display: inline-block;\n    font-size: 22px;\n    margin-left: 20px;\n    font-weight: 600;\n}\n\n\n.pay_loader, .pay_loader2{\n    width: 100%;\n}\n@media screen and (max-width:991px){\n    .payment_inner_box{\n        max-width: 90%;\n    }\n    .pay_logo img{\n        max-width: 100%;\n        height: auto;\n        padding: 0 20px;\n    }\n    /* .paymnt_partts{\n        margin: 0 20px;\n    } */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
